import React, { Component } from "react"
import { withStyles } from '@material-ui/core/styles';
import { TextField } from "@material-ui/core"
import Save from "../../../../assets/img/svg/save.svg"
import Cancel from "../../../../assets/img/svg/cancel.svg"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import $ from "jquery"
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Delete from "../../../../assets/img/svg/delete.svg"
import axios from "axios";
import API from "../../../../_helpers/endpointService"
import del from "../../../../assets/img/svg/Del.svg"
import Active from "../../../../assets/img/svg/active.svg";
import Deactive from "../../../../assets/img/svg/deactive.svg";
import Select from "react-select";
import { dropDownOptions } from "../../../common/commonFunction";

const customStyles = {
    control: (base, state) => ({
        ...base,
        borderColor: state.isFocused
            ? "red"
            : base.borderColor,
        '&:hover': {
            borderColor: state.isFocused
                ? "red"
                : base.borderColor,
        }
    })
};

class AddEditAdmin extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isMobile: false,
            menu: true,
            cancel: false,
            YardError: false,
            EmailError: false,
            isEdit: false,
            status: [],
            EmailCheck: false,
            NameError: false,
            EmptyNameError: false,
            ExistName: "",
            ExistEmail: "",
            Name: [],
            Email: [],
            addData: {
                "PageNumber": 0,
                "PageSize": 0,
                "UserId": 0,
                "Name": "",
                "Email": "",
                "ContactNumber": "",
                "YardName": "",
                "YardId": 0,
                "Status": "",
                "IsActive": false,
                "RoleId": 3,
                "RoleName": "",
                "CreatedBy": "",
                "CreatedDate": "",
                "ProjectIds": [],
                "ProjectList": [],
                "Key": "",
            },
            yardOptions: [],
            yardArray: [],
            defaultYardOptions: [],
            getLookupYard: {
                Name: "",
                PageNumber: 1,
                PageSize: 1000
            }
        }
    };

    componentDidMount() {
        window.location.pathname === "/usermanagement/yardowner/add" ? this.state.isEdit = false : this.state.isEdit = true;
        this.state.addData.Key = JSON.parse(localStorage.getItem("currentUser")).accessToken;
        this.setState({})

        // this.getEmailIds({
        //     "PageNumber": 1,
        //     "PageSize": 1000,
        //     "UserId": 0,
        //     "Name": "",
        //     "Email": "",
        //     "ContactNumber": "",
        //     "Status": "",
        //     "RoleId": 1,
        //     "RoleName": "",
        //     "CreatedBy": "",
        //     "CreatedDate": "",
        //     "ProjectIds": [],
        //     "ProjectList": []
        // })
        // this.getEmailIds({
        //     "PageNumber": 1,
        //     "PageSize": 1000,
        //     "UserId": 0,
        //     "Name": "",
        //     "Email": "",
        //     "ContactNumber": "",
        //     "Status": "",
        //     "RoleId": 2,
        //     "RoleName": "",
        //     "CreatedBy": "",
        //     "CreatedDate": "",
        //     "ProjectIds": [],
        //     "ProjectList": []
        // })
        // this.getEmailIds({
        //     "PageNumber": 1,
        //     "PageSize": 1000,
        //     "UserId": 0,
        //     "Name": "",
        //     "Email": "",
        //     "ContactNumber": "",
        //     "Status": "",
        //     "RoleId": 3,
        //     "RoleName": "",
        //     "CreatedBy": "",
        //     "CreatedDate": "",
        //     "ProjectIds": [],
        //     "ProjectList": []
        // })
        // this.getEmailIds({
        //     "PageNumber": 1,
        //     "PageSize": 1000,
        //     "UserId": 0,
        //     "Name": "",
        //     "Email": "",
        //     "ContactNumber": "",
        //     "Status": "",
        //     "RoleId": 4,
        //     "RoleName": "",
        //     "CreatedBy": "",
        //     "CreatedDate": "",
        //     "ProjectIds": [],
        //     "ProjectList": []
        // })

        this.getlookupYard(this.state.getLookupYard);

        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    getlookupYard = (data) => {
        let apiUrl = API.ACTION_YARDLOOKUP + '?Name=' + data.Name + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    response?.data?.YardData.sort((a, b) => {
                        return a.Id - b.Id;
                    })
                    this.setState({
                        yardOptions: dropDownOptions(response?.data?.YardData)?.props?.children
                    })
                    if (this.state.isEdit == true) {
                        this.getuserdatainfo(localStorage.getItem("EditUser"))
                    }
                } else {
                    if (this.state.isEdit == true) {
                        this.getuserdatainfo(localStorage.getItem("EditUser"))
                    }
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    getEmailIds = (data) => {
        let apiUrl = API.USER_MANAGEMENT;
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    if (response?.data?.Data.length > 0) {
                        response?.data?.Data.map((i) => {
                            if (i.Name != null && i.Name != undefined && i.Name != "") {
                                this.state.Name.push(i.Name);
                            }
                            if (i.Email != null && i.Email != undefined && i.Email != "") {
                                this.state.Email.push(i.Email);
                            }
                        })
                        this.setState({})
                    }
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });
    };

    AddCancel1 = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show")
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });

            this.props.navigate(`/usermanagement/yardowner`)
        }
    };

    getuserdatainfo = (data) => {
        let apiUrl = API.USER_DATA + data;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.addData.Name = response?.data?.Name;
                    this.state.addData.Email = response?.data?.Email;
                    this.state.ExistName = response?.data?.Name;
                    this.state.ExistEmail = response?.data?.Email;
                    this.state.addData.YardName = response?.data?.YardName;
                    this.state.addData.ContactNumber = response?.data?.ContactNumber;
                    this.state.addData.UserId = response?.data?.UserId;
                    this.state.addData.IsActive = response?.data?.IsActive;
                    this.state.addData.YardId = response?.data?.YardId;
                    this.state.yardArray = this.state.yardOptions?.filter((r) => parseInt(r.value?.split(",")[0]) == parseInt(response?.data?.YardId));
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#UYARD1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#UserMngt2 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#UserMngt22").addClass("d-none");
        $("#UserMngt22").removeClass("d-block");
        // $("#MOPA").removeClass("active-color");
        // $("#MOPAT").removeClass("fw-bolder");
    }

    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.navigate("/SidebarUser");
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        this.props.navigate("/SidebarUser");
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#UYARD1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#UserMngt2 .MuiListItemText-primary").addClass("fw-bolder");
        $("#UserMngt22").removeClass("d-none");
        $("#UserMngt22").addClass("d-block");
        // $("#MOPAT .MuiListItemText-primary").addClass("fw-bolder")
        // $("#MOPA").addClass("active-color")
    };

    handleInputChange = (e, node) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.addData[node] = e.target.value;
        this.setState({})
    };

    Save = () => {

        if (this.state.addData.YardName === '' || this.state.addData.YardName === undefined) {
            this.state.YardError = true;
            this.setState({})
        }
        else {
            this.state.YardError = false;
            this.setState({})
        }
        if (this.state.addData.Name === '') {
            this.state.EmptyNameError = true;
            this.setState({})
        }
        else {
            this.state.EmptyNameError = false;
            this.setState({})
        }
        // if (this.state.ExistName === this.state.addData.Name) {
        //     this.state.NameError = false;
        //     this.setState({})
        // }
        // else {
        //     let name = this.state.Name.filter((i) => i == this.state.addData.Name)
        //     if (this.state.addData.Name === name[0]) {
        //         this.state.NameError = true;
        //         this.setState({})
        //     } else {
        //         this.state.NameError = false;
        //         this.setState({})
        //     }
        // }
        let email = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
        if (email.test(this.state.addData.Email)) {
            this.state.EmailError = false;
            this.setState({})
            if (this.state.ExistEmail === this.state.addData.Email) {
                this.state.EmailCheck = false;
                this.setState({})
            }
            else {
                let type = this.state.Email.filter((i) => i == this.state.addData.Email)
                if (this.state.addData.Email === type[0]) {
                    this.state.EmailCheck = true;
                    this.setState({})
                } else {
                    this.state.EmailCheck = false;
                    this.setState({})
                }
            }
        }
        else {
            this.state.EmailCheck = false;
            this.state.EmailError = true;
            this.setState({})
        }
        if (this.state.EmailError == false && this.state.EmailCheck == false && this.state.EmptyNameError === false && this.state.YardError === false) {
            this.props.dispatch({ type: "CANCEL", data: false });
            if (this.state.addData.Name != "" && this.state.addData?.Name != null) {
                this.state.addData.Name = this.state.addData?.Name?.trim();
            }
            // if (this.state.addData.YardId != 0) {
            //     this.state.addData.YardName = this.state.addData?.YardName.trim();
            // }
            this.setState({})

            if (this.state.isEdit == false) {
                this.adduserdatainfo(this.state.addData)
            }
            else {
                this.putuserdatainfo(this.state.addData)
            }
        }
    };

    ChangeStatus = (val) => {
        let status = {
            "Id": localStorage.getItem("EditUser"),
            "Status": val
        }
        this.state.status.push(status)
        this.setState()
        this.ChangeUserStatus(this.state.status)
    }

    ChangeUserStatus = (data) => {
        let apiUrl = API.CHANGE_USERSTATUS;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate(`/usermanagement/yardowner`)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                }
            });
    };

    adduserdatainfo = (data) => {
        let apiUrl = API.ADDUSER_MANAGEMENT;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate(`/usermanagement/yardowner`)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    putuserdatainfo = (data, id) => {
        let apiUrl = API.ADDUSER_MANAGEMENT;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate(`/usermanagement/yardowner`)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    AddCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });

        window.$("#cancelpopup").modal("hide")
        this.props.navigate(`/usermanagement/yardowner`)
    };

    yardChange = (e) => {
        this.setState({
            addData: {
                ...this.state.addData,
                YardName: e?.value?.split(",")[1],
                YardId: e?.value?.split(",")[0] ? parseInt(e?.value?.split(",")[0]) : 0
            }
        })
        this.state.yardArray = e;
        this.setState({});
    }

    render() {
        const { isEdit } = this.state;
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={() => this.sidebar()} >
                                            <ListItemText id={"UYARD" + 1} className='  textNaviIcon' primary="Master Data" />
                                            <NavigateNextIcon id="UYARD" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5 ">
                                    {this.state.isEdit ? <h4 className="col-12">Edit Yard In Charge</h4> : <h4 className="col-12">Add New Yard In Charge</h4>}
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide height-div" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {
                        this.state.isMobile ?
                            <table className="dataTable border-top" width="100%">
                                <tbody>
                                    <tr>
                                        <td className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                        <td className="border-right text-center" >
                                            <button className={`${classes.button}`} onClick={() => { this.Save() }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                        </td>
                                        <td className="border-right text-center">
                                            <button className={`${classes.button} `} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                        </td>
                                        {/* {this.state.isEdit &&
                                            <td className="border-right text-center">
                                                <button className={`${classes.button} `} data-target="#deletepopup" data-toggle="modal" ><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</button>
                                            </td>} */}
                                    </tr>
                                </tbody>
                            </table>
                            :
                            <>
                                <table className="dataTable" width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="5%" className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                            <td className="" width="95%">
                                                <button className={`${classes.button}`} onClick={() => { this.Save() }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                                <button className={`${classes.button} pl-3`} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                                {this.state.isEdit && <>
                                                    {this.state.addData.IsActive && this.state.addData.IsActive == true ?
                                                        <button className={classes.button} style={{ minWidth: '70px' }} onClick={() => { this.ChangeStatus(false) }}><img src={Deactive} style={{ marginTop: '-4px' }}></img>&nbsp;Deactivate</button> :
                                                        <button className={classes.button} style={{ minWidth: '70px' }} onClick={() => { this.ChangeStatus(true) }}><img src={Active} style={{ marginTop: '-4px' }}></img>&nbsp;Activate</button>
                                                    } </>}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table></>}
                    <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        {this.state.isMobile ? <></> : this.state.isEdit ? <h6 className="col-12 mx-2 pt-2 ml-1">Edit Yard In Charge</h6> : <h6 className="col-12 mx-2 pt-2 ml-1">Add New Yard In Charge</h6>}
                        <div className={this.state.isMobile ? "row mt-1 mx-0 pr-2 pt-1" : "row mt-1 mx-3 pr-2 pt-1"}>
                            <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "float-end d-flex text-right"}>Name&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4 "}`}>
                                    {this.state.EmptyNameError ?
                                        <>
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                error
                                                value={this.state.addData.Name}
                                                onChange={(e) => { this.handleInputChange(e, "Name") }}
                                                fullWidth
                                                InputProps={{
                                                    className: `border-radius ${classes.inputfieldAlign}`
                                                }}
                                            // classes={{ root: classes.helperText1 }}
                                            // helperText={this.state.NameError ? "User Already Exists" : ""}
                                            />
                                        </> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            value={this.state.addData.Name}
                                            onChange={(e) => { this.handleInputChange(e, "Name") }}
                                            fullWidth
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                    }
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "float-end d-flex text-right"}>Email ID&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4 "}`}>
                                    {(this.state.EmailError || this.state.EmailCheck) ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.Email}
                                            onChange={(e) => { this.handleInputChange(e, "Email") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText1 }}
                                            helperText={this.state.EmailCheck ? "User Already Exists" : ""}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.Email}
                                            onChange={(e) => { this.handleInputChange(e, "Email") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "pt-2" : "float-end text-right"}>Contact Number&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        type="number"
                                        value={this.state.addData.ContactNumber}
                                        onChange={(e) => { this.handleInputChange(e, "ContactNumber") }}
                                        fullWidth
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : " float-end d-flex text-right"}>Recycling Yard Name&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12  col-xl-3 col-lg-4  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-10 pt-4 pb-4 "}`}>
                                    <Select
                                        styles={customStyles}
                                        options={this.state.yardOptions ?? []}
                                        value={this.state.yardArray}
                                        menuPortalTarget={document.body}
                                        menuShouldScrollIntoView={false}
                                        classNamePrefix={this.state.YardError ? "yardNameError" : "yardName"}
                                        isSearchable={true}
                                        placeholder=""
                                        onChange={(e) => this.yardChange(e)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" data-dismiss="modal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                <button type="button" onClick={() => { window.$("#deletepopup").modal("hide") }} data-dismiss="modal" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} data-dismiss="modal" onClick={this.AddCancel}><span className="" >Yes</span></button>
                                <button type="button" id="closemodal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        Lookup_Yard: state.MasterDataReducer.Lookup_yard,
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddEditAdmin))
);
